
import { computed, defineComponent, ref } from "vue";
import planetData from "@/data/data.json";
import { onBeforeRouteUpdate, useRoute } from "vue-router";

export default defineComponent({
  setup(props) {
    const route = useRoute();
    const name = ref(route.params.name);
    const showPlanet = ref(true);
    const showInternal = ref(false);
    const showSurface = ref(false);

    onBeforeRouteUpdate((to) => {
      name.value = to.params.name;
    });

    const planet = computed(() => {
      return planetData.find((p) => p.name.toLowerCase() === name.value);
    });

    const updateImage = (layer) => {
      switch (layer) {
        case "overview":
          showPlanet.value = true;
          showInternal.value = false;
          showSurface.value = false;
          break;
        case "structure":
          showPlanet.value = false;
          showInternal.value = true;
          showSurface.value = false;
          break;
        case "surface":
          showPlanet.value = false;
          showInternal.value = false;
          showSurface.value = true;
          break;
        default:
          break;
      }
    };

    return { planet, showPlanet, showInternal, showSurface, updateImage };
  },
});
